import NotFound from './NotFound';
import {Link} from 'react-router-dom';
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/config";
import { Swiper, SwiperSlide } from 'swiper/react';
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Overlay from '../components/Overlay';
import { Helmet } from 'react-helmet';

function BlogDetail() {
    const { slug } = useParams();
    const [missingSlug, setMissingSlug] = useState(null);
    const navigate = useNavigate();
    const [blogetail, setblogetail] = useState({});
    const [relatedblogs, setrelatedblogs] = useState([]);
    const [showloding, setshowloding] = useState(false);
    

    const DisplayOnlyText = (data) => {
        const parser = new DOMParser();
        var datas = data;
        const htmlString = data;
        return (
          <div dangerouslySetInnerHTML={{ __html: htmlString }} />
        );
      };

    const fetchblogdetails = async(slug) => {
        setshowloding(true);
        setMissingSlug(null);
        var data = {
            slug: slug
        };
        const headers = {
            headers: {
              "Content-Type": "application/json",
            },
          };

          let resp = await axios
    .post(apiUrl + "getblogdetails",data, headers)
    .then((res) => {
      // console.log('res >>', res.data)
      if(res?.data?.data?.length > 0) {
        setblogetail(res?.data?.data[0]);
      } else {
        setblogetail({});
        setMissingSlug(slug);
        return;
      }

      if(res?.data?.allblogs?.length > 0) {
        setrelatedblogs(res?.data?.allblogs);
      } else {
        setrelatedblogs([]);
      }



     })
     .catch((err) => {
      if (err.response?.status === 404) {
        setMissingSlug(slug);
      } else {
        alert(err.message);
      }
    });
        setshowloding(false);
    }

    const handlenavigation = (data) => {
        navigate('/blog/'+data?.slug)
      }

    useEffect(() => {
        fetchblogdetails(slug);
    }, [slug])

    console.log('slug >>', slug);
  if (missingSlug === slug) return <NotFound />;

  return (
    <>
    {
      slug == "Vinyl-Records-:-The-Timeless-Treasures-Of-Music" ?
      <Helmet>
        {/* 🌟 Meta Tags for SEO */}
        <title>Vinyl Records: Timeless Treasures of Music</title>
        <meta name="description" content="Understand why vinyl records remain loved by collectors, music fans and audiophiles. Learn what makes LPs collectible and where to shop vinyl in India." />
        <meta name="author" content="Blisstainment" />

       
        {/* ✅ Primary Keyword */}
        <meta name="keywords" content="vinyl records guide" />

        {/* ✅ Canonical Tag */}
        <link rel="canonical" href="https://www.blisstainment.com/blog/Vinyl-Records-:-The-Timeless-Treasures-Of-Music" />

        {/* ✅ Open Graph (OG) Tags - For Social Media */}
        {/* <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:url" content="" />
        <meta property="og:image" content=""/>
        <meta property="og:type" content="website" /> */}


        
      </Helmet> :

      slug == "7-Reasons-Why-It’s-Never-Too-Late-to-Start-Your-Vinyl-Collection" ?
      <Helmet>
        {/* 🌟 Meta Tags for SEO */}
        <title>7 Reasons to Start Your Vinyl Collection Today</title>
        <meta name="description" content="Thinking of collecting vinyl records? Learn why LPs are loved, how to start your collection and which records to explore first in India." />
        <meta name="author" content="Blisstainment" />

       
        {/* ✅ Primary Keyword */}
        <meta name="keywords" content="start vinyl collection" />

        {/* ✅ Canonical Tag */}
        <link rel="canonical" href="https://www.blisstainment.com/blog/7-Reasons-Why-It%E2%80%99s-Never-Too-Late-to-Start-Your-Vinyl-Collection" />

        {/* ✅ Open Graph (OG) Tags - For Social Media */}
        {/* <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:url" content="" />
        <meta property="og:image" content=""/>
        <meta property="og:type" content="website" /> */}


        
      </Helmet> :

      <Helmet>
              {/* 🌟 Meta Tags for SEO */}
              <title>Buy Vinyl Records Online in India | Blisstainment</title>
              <meta name="description" content="Shop Hindi, Tamil, English and pre-owned vinyl records, CDs and accessories at Blisstainment. Discover new releases, pre-books and collector LPs across India." />
              <meta name="author" content="Blisstainment" />
      
             
              {/* ✅ Primary Keyword */}
              <meta name="keywords" content="buy vinyl records online India" />
      
              {/* ✅ Canonical Tag */}
              <link rel="canonical" href="https://www.blisstainment.com/" />
      
              {/* ✅ Open Graph (OG) Tags - For Social Media */}
              {/* <meta property="og:title" content="" />
              <meta property="og:description" content="" />
              <meta property="og:url" content="" />
              <meta property="og:image" content=""/>
              <meta property="og:type" content="website" /> */}
      
      
              
            </Helmet>
    }
    <Overlay showloader={showloding} />
      <section className="brand-color pd50 relative blogdetailsection">
      <div className="container">
        <div className="row ">
          <div className="col-md-8">
            {Object.keys(blogetail)?.length > 0 ? (
              
                <div className="">
                  <h2 className="uppercase text-black blocktitle">{blogetail?.title}</h2>
                  <img src={assetsUrl + "blogs/" + blogetail?.image} className='blogimage' />
                  <p className="weight600">
                    {
                      DisplayOnlyText(blogetail?.description)
                    }
                  </p>
                </div>
            ) : (
              <div className="container">
                <div className="about-page">
                  <h3 className="uppercase text-black">Not Found</h3>
                </div>
              </div>
            )}
          </div>
          <div className="col-md-4">
            <div className='blogrightdiv'>
                <h2 className="uppercase text-black relatedbloghead">Related Blogs</h2>
                {
                    relatedblogs?.length > 0 ?
                    relatedblogs?.map((item, index) => {
                        if(item?.slug !== slug) {
                        return (
                        <div className='relatedblogdiv' key={index} onClick={() => {handlenavigation(item)}}>
                            <img src={assetsUrl + "blogs/" + item?.image} className='relatedblogimg' />
                            <h5 className="uppercase text-black relatedblogtitle">{item?.title}</h5>
                         </div>
                        )
                    }
                    })
                    :
                    <h4 className="uppercase text-black mt-3">No Post</h4>
                }
            </div>
           
          </div>
        </div>
        <div className='' style={{position: 'relative'}}>
        <div className="home_btn_div" style={{bottom: -65}}>
              <Link to="contact-us" className="home_btn">
                Contact
              </Link>
            </div>
        </div>
        </div>
      </section>
    </>
  );
}

export default BlogDetail